module.exports = __webpack_public_path__ + "static/media/galeryAbout5.01711583.jpg";